import { useRefreshTokenMutation } from "features/auth/auth";
import { useAppSelector } from "features/store";
import { botsManagementWs } from "features/ws/botsManagementWs";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function BotsManagementWsConnector() {
  const location = useLocation();
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);
  const accessToken = useAppSelector((state) => state.auth.accessToken);
  const [refreshToken] = useRefreshTokenMutation();

  const onBotsManagement = location.pathname.startsWith("/bots-management");

  useEffect(() => {
    botsManagementWs.setTokenProvider(() => localStorage.getItem("accessToken"));
    return () => {
      botsManagementWs.setTokenProvider(null);
    };
  }, []);

  useEffect(() => {
    const unsubscribe = botsManagementWs.subscribeAuthRejected(() => {
      refreshToken()
        .unwrap()
        .then((result) => {
          if (result?.access) {
            botsManagementWs.connect(result.access);
          }
        })
        .catch(() => {
          // Wait for Redux token update or user navigation.
        });
    });
    return unsubscribe;
  }, [refreshToken]);

  useEffect(() => {
    if (!isAuthenticated || !accessToken || !onBotsManagement) {
      botsManagementWs.disconnect();
      return;
    }
    botsManagementWs.connect(accessToken);
  }, [isAuthenticated, accessToken, onBotsManagement]);

  return null;
}

export default BotsManagementWsConnector;
